import WidgetModule from "@eisinc/Overrides/Widgets/ProductList/ProductListBrandFilters";

export * from "@eisinc/Overrides/Widgets/ProductList/ProductListBrandFilters";

export default WidgetModule;
